import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { actions as majorqueryActions } from "../../../../../../redux/modules/majorquery";
import { get } from "../../../../../../utils/request";
import "./style.css";
import "../../../../../../index.css";
class MajorQueryHotMajor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    this.requestHotMajor();
  }
  render() {
    const { visible } = this.props;
    const { data } = this.state;
    return (
      <div
        className={
          visible === true
            ? "majorQueryHotMajor_box"
            : "majorQueryHotMajor_box display_none"
        }
      >
        {data != null
          ? data.map((item, index) => {
              return (
                <div
                  onClick={this.handleClick.bind(this, item)}
                  className="fl majorQueryHotMajor_box_major"
                  key={index}
                >
                  {item.name}
                </div>
              );
            })
          : ""}
        <div className="clear"></div>
      </div>
    );
  }

  /**
   * 点击专业跳转到专业查询列表页面
   */
  handleClick = (item) => {
    this.storageMajor(item.name);
    this.props.history.push("/majorquery/list");
  };

  /**
   * 存数据
   */
  storageMajor = (name) => {
    //todo 点击专业的时候 将专业存入redux 以及 sessionStorage 并且跳转到专业查询列表页面
    //存两份数据 一份存sessionStorage，一份存redux 。
    const { dispatch } = this.props;
    dispatch(majorqueryActions.cacheMajor(name));
    sessionStorage.setItem("query_major", JSON.stringify(name));
  };
  /**
   * 返回所有的热门专业
   */
  requestHotMajor = () => {
    get("/public/v1/common/hot/major").then((res) => {
      this.setState({
        data: res.data,
      });
    });
  };
}

export default connect()(withRouter(MajorQueryHotMajor));



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/MajorQuery/components/MajorQueryHotMajor/index.js